module.exports = __webpack_public_path__ + "img/no-preview.0afd87e8.svg";